<template>
    <div class="flex items-center align-center justify-center w-full">
        <h2 class="text-center text-3xl" v-if="!error">Processing Xero Authentication, Please Wait...</h2>
        <p class="text-center text-xl text-red-500" v-else>{{ error }}</p>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "XeroOAth",
        data() {
            return {
                error: null
            }
        },
        methods: {
            handleCallback: function(){
                const params = new URLSearchParams(window.location.search);
                let code = params.get('code');

                axios.post(process.env.VUE_APP_API_URL + '/auth/xero/callback', {
                    code: code
                }).then(response => {
                    if (response.data.success){
                        console.log(response);
                        this.$router.push('/dashboard');
                    }
                }).catch(error => {
                    this.error = error.message
                })
            }
        },
        beforeMount() {
            this.handleCallback();
        }
    }
</script>

<style scoped>

</style>
